import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthorizationHeader, http } from '../../config/http';
import { PhotoView } from 'react-photo-view';
import {
  IconCalendarTime,
  IconChevronLeft,
  IconChevronRight,
  IconReload,
  IconSearch,
  IconBuildingStore,
  IconDiamond,
  IconScale,
  IconPhoto,
  IconInbox,
  IconLoader2,
  IconBox,
  IconLayoutGrid,
  IconX,
} from '@tabler/icons-react';
import moment from 'moment';
import useCabang from '../features/useCabang';
import { DinamicTitle } from '../../utils/DinamicTitle';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import Layouts from '../../layouts/Layouts';
import useKarat from '../features/useKarat';
import { resolveItemImageUrl } from '../../utils/itemImage';

const GaleriBarang = () => {
  DinamicTitle('Galeri Barang');
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalModal, setTotalModal] = useState(0);
  const [totalModalFilter, setTotalModalFilter] = useState(0);
  const [jmlBarang, setJmlBarang] = useState(0);
  const [jmlBerat, setJmlBerat] = useState(0);
  const [page, setPage] = useState(0);

  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');
  const [kategori, setKategori] = useState([]);
  const [bakiId, setBakiId] = useState('');
  const [filterBaki, setFilterBaki] = useState([]);
  const [selectCabang, setSelectCabang] = useState('');
  const { karatOption, karatOptionId, setKaratOptionId } = useKarat();
  const { cabang } = useCabang();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = useRef(null);

  const awal = startDate ? moment(startDate).format('DD-MM-YYYY') : '';
  const akhir = endDate ? moment(endDate).format('DD-MM-YYYY') : '';

  const [search, setSearch] = useState('');
  const [gridCols, setGridCols] = useState('4');

  useEffect(() => {
    const numbersArray = [];
    for (let i = 1; i <= 20; i++) {
      numbersArray.push(i);
    }
    setFilterBaki(numbersArray);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (datePickerRef.current && !datePickerRef.current.contains(e.target)) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  async function getKategori() {
    try {
      const res = await http.get('/kategori', {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setKategori(res.data || []);
    } catch (err) {
      if (err.response?.status === 401) {
        navigate('/login');
      }
    }
  }

  useEffect(() => {
    getKategori();
  }, [navigate]);

  async function getItems(overrideQuery = null) {
    setLoading(true);
    try {
      let query;
      if (typeof overrideQuery === 'string') {
        query = overrideQuery;
      } else {
        const params = [`per_page=12`];
        if (search) params.push(`kode=${encodeURIComponent(search)}`);
        else params.push(`page=${currentPage}`);

        if (selectedKategori) params.push(`kategori=${selectedKategori}`);
        if (selectJenisKategori) params.push(`jenis_kategori=${selectJenisKategori}`);
        if (selectCabang) params.push(`cabang=${selectCabang}`);
        if (startDate && endDate) {
          params.push(`tgl_awal=${awal}`);
          params.push(`tgl_akhir=${akhir}`);
        }
        if (bakiId) params.push(`no_baki=${bakiId}`);
        if (karatOptionId) params.push(`karat=${karatOptionId}`);

        query = `?${params.join('&')}`;
      }

      const res = await http.get(`/item${query}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });

      setItems(res.data?.data?.data || []);
      setTotalModal(res.data?.total_modal || 0);
      setTotalModalFilter(res.data?.total_modal_filter || 0);
      setJmlBarang(res.data?.data?.total || 0);
      setPage(res.data?.data?.last_page || 1);
      setJmlBerat(res.data?.total_berat_page || 0);
      setCurrentPage(res.data?.data?.current_page || 1);
    } catch (err) {
      if (err.response?.status === 401) {
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  }

  const handleReload = () => {
    setSelectedKategori('');
    setSelectJenisKategori('');
    setBakiId('');
    setSelectCabang('');
    setKaratOptionId('');
    setStartDate(null);
    setEndDate(null);
    setSearch('');
    setCurrentPage(1);
    getItems('?per_page=12&page=1');
  };

  useEffect(() => {
    getItems();
  }, [
    selectedKategori,
    bakiId,
    search.length >= 5 ? search : search === '' ? '' : null,
    selectJenisKategori,
    currentPage,
    selectCabang,
    startDate,
    endDate,
    karatOptionId,
  ]);

  function numberWithCommas(x) {
    if (!x || isNaN(x)) return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
    setCurrentPage(1);
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
    setCurrentPage(1);
  };

  const selectionRange = {
    startDate: startDate || new Date(),
    endDate: endDate || new Date(),
    key: 'selection',
  };

  function handleSelect(ranges) {
    setStartDate(ranges.selection.startDate);
    setEndDate(ranges.selection.endDate);
  }

  function prevPage() {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  }

  function nextPage() {
    if (currentPage < page) setCurrentPage(currentPage + 1);
  }

  return (
    <Layouts //title="Galeri Barang"
    >
      <div className="p-3 sm:p-5 lg:p-6 w-full space-y-4 flex-1 flex flex-col">
        {/* ========================================================================= */}
        {/* GOLD THEME FILTER & ACTION TOOLBAR                                       */}
        {/* ========================================================================= */}
        <div className="bg-white dark:bg-slate-900 border border-slate-200/80 dark:border-slate-800 shadow-sm rounded-2xl p-3 sm:p-4">
          <div className="flex items-center gap-2.5 overflow-x-auto pb-1 custom-scrollbar">
            {/* PENCARIAN KODE BARANG */}
            <div className="min-w-[170px] sm:min-w-[210px] flex-1">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Pencarian
              </label>
              <div className="relative">
                <IconSearch
                  size={15}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
                />
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Cari Kode Barang..."
                  className="w-full pl-9 pr-3 py-2 text-xs font-semibold bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition shadow-sm"
                />
              </div>
            </div>

            {/* RENTANG TANGGAL FILTER */}
            <div className="min-w-[150px] sm:min-w-[170px]">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Rentang Tanggal
              </label>
              <div className="relative" ref={datePickerRef}>
                <button
                  type="button"
                  onClick={() => setShowDatePicker(!showDatePicker)}
                  className={`w-full px-3 py-2 rounded-xl border text-xs font-semibold transition-all flex items-center justify-between gap-1.5 cursor-pointer shadow-sm ${
                    startDate && endDate
                      ? 'bg-amber-500 text-white border-amber-600 shadow-amber-500/20'
                      : 'bg-slate-50 dark:bg-slate-800/80 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700 hover:border-amber-400'
                  }`}
                  title="Filter Rentang Tanggal"
                >
                  <div className="flex items-center gap-1.5 truncate">
                    <IconCalendarTime size={15} className={startDate && endDate ? 'text-white' : 'text-amber-600 dark:text-amber-400'} />
                    <span className="truncate">
                      {startDate && endDate
                        ? `${moment(startDate).format('DD/MM')} - ${moment(endDate).format('DD/MM')}`
                        : 'Semua Tanggal'}
                    </span>
                  </div>
                </button>
                {showDatePicker && (
                  <div
                    className="fixed inset-0 z-[9999] flex items-center justify-center p-3 sm:p-4 bg-slate-900/60 backdrop-blur-xs"
                    onClick={(e) => {
                      if (e.target === e.currentTarget) setShowDatePicker(false);
                    }}
                  >
                    <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-800 p-3 sm:p-4 max-w-sm sm:max-w-md w-full overflow-hidden">
                      <div className="flex items-center justify-between pb-3 mb-2 border-b border-slate-100 dark:border-slate-800">
                        <div className="flex items-center gap-2">
                          <IconCalendarTime size={18} className="text-amber-500" />
                          <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100">
                            Pilih Rentang Tanggal
                          </h3>
                        </div>
                        <button
                          type="button"
                          onClick={() => setShowDatePicker(false)}
                          className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition cursor-pointer"
                        >
                          <IconX size={18} />
                        </button>
                      </div>

                      <div className="flex justify-center overflow-x-auto py-1">
                        <DateRange
                          ranges={[selectionRange]}
                          onChange={handleSelect}
                          moveRangeOnFirstSelection={false}
                          rangeColors={['#f59e0b']}
                        />
                      </div>

                      <div className="flex items-center justify-between gap-2 pt-3 mt-2 border-t border-slate-100 dark:border-slate-800">
                        <button
                          type="button"
                          onClick={() => {
                            setStartDate(null);
                            setEndDate(null);
                            setShowDatePicker(false);
                          }}
                          className="px-3 py-1.5 text-xs font-semibold text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/40 rounded-lg transition cursor-pointer"
                        >
                          Reset Tanggal
                        </button>
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            onClick={() => setShowDatePicker(false)}
                            className="px-3 py-1.5 text-xs font-semibold text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition cursor-pointer"
                          >
                            Batal
                          </button>
                          <button
                            type="button"
                            onClick={() => setShowDatePicker(false)}
                            className="px-4 py-1.5 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-xs font-bold transition shadow-sm cursor-pointer"
                          >
                            Terapkan
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* ETALASE / CABANG SELECT */}
            <div className="min-w-[130px] sm:min-w-[150px]">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Etalase / Toko
              </label>
              <div className="relative">
                <select
                  value={selectCabang}
                  onChange={(e) => {
                    setSelectCabang(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="w-full text-xs font-semibold bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-xl px-3 py-2 pr-8 focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition cursor-pointer appearance-none"
                >
                  <option value="">Semua Etalase</option>
                  {cabang.map((cb) => (
                    <option key={cb.id} value={cb.id}>
                      {cb.nama_cabang}
                    </option>
                  ))}
                </select>
                <div className="absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                  <IconBuildingStore size={14} />
                </div>
              </div>
            </div>

            {/* KATEGORI SELECT */}
            <div className="min-w-[120px] sm:min-w-[140px]">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Kategori
              </label>
              <select
                value={selectedKategori}
                onChange={handleKategoriChange}
                className="w-full text-xs font-semibold bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition cursor-pointer"
              >
                <option value="">Semua Kategori</option>
                {kategori.map((kt) => (
                  <option key={kt.id} value={kt.id}>
                    {kt.nama_kategori}
                  </option>
                ))}
              </select>
            </div>

            {/* JENIS KATEGORI SELECT */}
            {selectedKategori && (
              <div className="min-w-[130px] sm:min-w-[150px] animate-in fade-in">
                <label className="block text-[10px] font-bold text-amber-700 dark:text-amber-400 uppercase tracking-wider mb-1">
                  Jenis Kategori
                </label>
                <select
                  value={selectJenisKategori}
                  onChange={handleJenisKategoriChange}
                  className="w-full text-xs font-semibold bg-amber-50 dark:bg-amber-950/30 border border-amber-300 dark:border-amber-800 rounded-xl px-3 py-2 text-amber-900 dark:text-amber-300 focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition cursor-pointer"
                >
                  <option value="">Semua Jenis</option>
                  {kategori
                    .find((kt) => String(kt.id) === String(selectedKategori))
                    ?.jenis_kategori?.map((jk) => (
                      <option key={jk.id} value={jk.id}>
                        {jk.nama_jenis}
                      </option>
                    ))}
                </select>
              </div>
            )}



            {/* BAKI SELECT */}
            <div className="min-w-[95px] sm:min-w-[105px]">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Baki
              </label>
              <select
                value={bakiId}
                onChange={(e) => {
                  setBakiId(e.target.value);
                  setCurrentPage(1);
                }}
                className="w-full text-xs font-semibold bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition cursor-pointer"
              >
                <option value="">Semua Baki</option>
                {filterBaki.map((b) => (
                  <option key={b} value={b}>
                    Baki #{b}
                  </option>
                ))}
              </select>
            </div>

            {/* KARAT SELECT */}
            <div className="min-w-[100px] sm:min-w-[115px]">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Karat
              </label>
              <div className="relative">
                <select
                  value={karatOptionId}
                  onChange={(e) => {
                    setKaratOptionId(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="w-full text-xs font-semibold bg-slate-50 dark:bg-slate-800/80 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 rounded-xl px-3 py-2 pr-7 focus:outline-none focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition cursor-pointer appearance-none"
                >
                  <option value="">Semua Karat</option>
                  {karatOption.map((kto) => (
                    <option key={kto} value={kto}>
                      {kto} K
                    </option>
                  ))}
                </select>
                <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                  <IconDiamond size={13} />
                </div>
              </div>
            </div>

            {/* RELOAD BUTTON (API ONLY, PAGE 1, EMPTY FILTER) */}
            <div className="flex flex-col justify-end">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1 opacity-0 pointer-events-none hidden sm:block">
                Reload
              </label>
              <button
                type="button"
                onClick={handleReload}
                disabled={loading}
                className="h-[36px] px-3 bg-amber-500 hover:bg-amber-600 active:scale-95 text-white rounded-xl text-xs font-semibold transition-all flex items-center gap-1.5 shadow-sm shadow-amber-500/20 cursor-pointer disabled:opacity-50"
                title="Muat Ulang API (Kembali ke Hal 1 & Reset Filter)"
              >
                <IconReload size={15} className={loading ? 'animate-spin' : ''} />
                <span className="hidden sm:inline">Reload</span>
              </button>
            </div>

            {/* RESET BUTTON */}
            {(selectCabang || selectedKategori || selectJenisKategori || bakiId || karatOptionId || search || startDate) && (
              <div className="flex flex-col justify-end">
                <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1 opacity-0 pointer-events-none hidden sm:block">
                  Reset
                </label>
                <button
                  type="button"
                  onClick={handleReload}
                  className="h-[36px] px-3 text-xs font-bold text-rose-500 hover:text-rose-600 bg-rose-50 dark:bg-rose-950/40 hover:bg-rose-100 rounded-xl transition cursor-pointer"
                  title="Reset Semua Filter"
                >
                  Reset
                </button>
              </div>
            )}

            {/* PILIHAN UKURAN TAMPILAN FOTO / GRID */}
            <div className="flex flex-col justify-end ml-auto">
              <label className="block text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1">
                Ukuran Foto
              </label>
              <div className="flex items-center bg-slate-100 dark:bg-slate-800 p-0.5 rounded-xl border border-slate-200 dark:border-slate-700 h-[36px]">
                <button
                  type="button"
                  onClick={() => {
                    setGridCols('2');
                    localStorage.setItem('galeri_grid_cols', '2');
                  }}
                  className={`px-3 py-1 rounded-lg text-xs font-bold transition-all flex items-center gap-1.5 cursor-pointer ${
                    gridCols === '2'
                      ? 'bg-amber-500 text-white shadow-sm shadow-amber-500/20'
                      : 'text-slate-600 dark:text-slate-300 hover:text-amber-600'
                  }`}
                  title="Tampilan Penuh / Besar (2 Kolom - Sangat Lebar)"
                >
                  <IconLayoutGrid size={15} />
                  <span>Besar (Penuh)</span>
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setGridCols('3');
                    localStorage.setItem('galeri_grid_cols', '3');
                  }}
                  className={`px-2.5 py-1 rounded-lg text-xs font-bold transition-all flex items-center gap-1 cursor-pointer ${
                    gridCols === '3'
                      ? 'bg-amber-500 text-white shadow-sm shadow-amber-500/20'
                      : 'text-slate-600 dark:text-slate-300 hover:text-amber-600'
                  }`}
                  title="Tampilan Sedang (3 Kolom)"
                >
                  <span>Sedang</span>
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setGridCols('4');
                    localStorage.setItem('galeri_grid_cols', '4');
                  }}
                  className={`px-2.5 py-1 rounded-lg text-xs font-bold transition-all flex items-center gap-1 cursor-pointer ${
                    gridCols === '4'
                      ? 'bg-amber-500 text-white shadow-sm shadow-amber-500/20'
                      : 'text-slate-600 dark:text-slate-300 hover:text-amber-600'
                  }`}
                  title="Tampilan Kompak (4 Kolom)"
                >
                  <span>Kompak</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ========================================================================= */}
        {/* GALLERY ITEMS GRID                                                        */}
        {/* ========================================================================= */}
        {loading ? (
          <div className="flex flex-col items-center justify-center p-16 bg-white dark:bg-slate-900 rounded-3xl border border-slate-200/80 dark:border-slate-800 my-auto">
            <div className="w-14 h-14 rounded-2xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center text-amber-600 mb-3 shadow-inner">
              <IconLoader2 size={30} className="animate-spin text-amber-500" />
            </div>
            <p className="text-sm font-bold text-slate-800 dark:text-slate-100">Memuat Galeri Barang...</p>
            <p className="text-xs text-slate-400 mt-1">Mengambil foto dan rincian produk emas...</p>
          </div>
        ) : items.length === 0 ? (
          <div className="flex flex-col items-center justify-center p-16 bg-white dark:bg-slate-900 rounded-3xl border border-slate-200/80 dark:border-slate-800 text-center my-auto">
            <div className="w-16 h-16 rounded-2xl bg-amber-500/10 dark:bg-amber-400/10 border border-amber-500/20 flex items-center justify-center text-amber-600 dark:text-amber-400 mb-3">
              <IconInbox size={34} />
            </div>
            <h3 className="text-base font-bold text-slate-800 dark:text-slate-100 mb-1">
              Tidak Ada Foto Barang Ditemukan
            </h3>
            <p className="text-xs text-slate-400 max-w-sm">
              Tidak ada data barang yang sesuai dengan filter atau kata kunci pencarian Anda.
            </p>
          </div>
        ) : (
          <div
            className={`grid gap-4 sm:gap-6 pb-6 ${
              gridCols === '2'
                ? 'grid-cols-1 md:grid-cols-2'
                : gridCols === '3'
                ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3'
                : 'grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4'
            }`}
          >
            {items.map((item, index) => {
              const imgUrl = resolveItemImageUrl(item);
              return (
                <div
                  key={item.id || index}
                  className="group relative overflow-hidden rounded-2xl border border-slate-200/90 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-sm hover:shadow-xl hover:border-amber-500/50 transition-all duration-300 flex flex-col"
                >
                  {/* Photo Container */}
                  <div className="relative aspect-[16/10] sm:aspect-[16/9] bg-slate-100 dark:bg-slate-800/80 overflow-hidden flex items-center justify-center cursor-pointer">
                    {imgUrl ? (
                      <PhotoView src={imgUrl}>
                        <img
                          src={imgUrl}
                          alt={item?.kode_item || 'Barang Emas'}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </PhotoView>
                    ) : (
                      <div className="flex flex-col items-center justify-center text-slate-400 dark:text-slate-500 gap-1.5 p-4 text-center">
                        <IconPhoto size={36} className="text-amber-500/40" />
                        <span className="text-[11px] font-medium">Foto Tidak Tersedia</span>
                      </div>
                    )}

                    {/* Top Badges */}
                    <div className="absolute top-2.5 left-2.5 right-2.5 flex items-center justify-between gap-1.5 pointer-events-none">
                      {/* Cabang Badge */}
                      <span className="inline-flex items-center gap-1 bg-amber-600/90 hover:bg-amber-600 text-white text-[11px] font-extrabold px-2.5 py-1 rounded-lg backdrop-blur-md shadow-md border border-amber-400/30">
                        <IconBuildingStore size={12} />
                        <span className="truncate max-w-[120px]">
                          {item?.cabang?.nama_cabang || 'Etalase'}
                        </span>
                      </span>

                      {/* Karat Badge */}
                      <span className="inline-flex items-center gap-1 bg-amber-600/90 hover:bg-amber-600 text-white text-[11px] font-extrabold px-2.5 py-1 rounded-lg backdrop-blur-md shadow-md border border-amber-400/30">
                        <IconDiamond size={12} />
                        {item?.karat || 0}K
                      </span>
                    </div>

                    {/* Baki Tag if available */}
                    {item?.nomor_rak && (
                      <div className="absolute bottom-2.5 left-2.5 pointer-events-none">
                        <span className="inline-flex items-center gap-1 bg-slate-900/80 text-slate-200 text-[10px] font-bold px-2 py-0.5 rounded-md backdrop-blur-md border border-slate-700 shadow-sm">
                          <IconBox size={11} />
                          Baki #{item.nomor_rak}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Card Body (Gold Theme) */}
                  <div className="p-3.5 sm:p-4 flex-1 flex flex-col justify-between space-y-2.5 border-t border-slate-100 dark:border-slate-800">
                    <div>
                      {/* Kode & Kategori */}
                      <div className="flex items-center justify-between gap-2 mb-1">
                        <span className="font-mono text-xs font-bold text-amber-600 dark:text-amber-400 tracking-wider">
                          {item?.kode_item}
                        </span>
                        <span className="text-[11px] font-semibold text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-800 px-2 py-0.5 rounded-md truncate max-w-[110px]">
                          {item?.jenis_kategori?.nama_jenis || item?.kategori?.nama_kategori || 'Perhiasan'}
                        </span>
                      </div>
                    </div>

                    {/* Meta Spec Bar */}
                    <div className="pt-2 border-t border-slate-100 dark:border-slate-800 flex items-center justify-between">
                      {/* Berat */}
                      <div className="flex items-center gap-1 text-xs text-slate-600 dark:text-slate-300 font-bold">
                        <IconScale size={14} className="text-amber-500" />
                        <span>{parseFloat(item?.berat || 0).toFixed(3)} gr</span>
                      </div>

                      {/* Harga Modal (Gold Highlight) */}
                      <div className="text-right">
                        <span className="text-[10px] uppercase font-bold text-slate-400 block -mb-0.5">
                          Modal
                        </span>
                        <span className="text-xs sm:text-sm font-black text-amber-600 dark:text-amber-400">
                          Rp {numberWithCommas(item?.harga_modal || 0)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ========================================================================= */}
      {/* STICKY BOTTOM SUMMARY BAR (GOLD EXECUTIVE THEME)                         */}
      {/* ========================================================================= */}
      <div className="sticky bottom-0 z-20 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border-t border-slate-200 dark:border-slate-800 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] px-4 sm:px-6 py-3 transition-colors">
        <div className="w-full flex flex-col md:flex-row items-center justify-between gap-3">
          {/* Metrics Summary Badges */}
          <div className="flex items-center gap-3 sm:gap-6 flex-wrap justify-center md:justify-start">
            {/* Total Modal */}
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-amber-500/10 dark:bg-amber-400/10 border border-amber-500/20">
              <span className="text-xs font-bold text-amber-700 dark:text-amber-300 uppercase tracking-wider">
                Total Modal:
              </span>
              <span className="text-xs sm:text-sm font-extrabold text-amber-600 dark:text-amber-400">
                Rp {numberWithCommas(totalModal === totalModalFilter ? totalModal : totalModalFilter)}
              </span>
            </div>

            {/* Total Barang */}
            <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-600 dark:text-slate-300">
              <span className="text-slate-400 uppercase font-bold text-[11px]">Jumlah:</span>
              <span className="px-2 py-0.5 rounded-lg bg-slate-100 dark:bg-slate-800 font-bold text-slate-800 dark:text-slate-100">
                {jmlBarang} item
              </span>
            </div>

            {/* Total Berat */}
            <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-600 dark:text-slate-300">
              <span className="text-slate-400 uppercase font-bold text-[11px]">Berat:</span>
              <span className="px-2 py-0.5 rounded-lg bg-slate-100 dark:bg-slate-800 font-bold text-slate-800 dark:text-slate-100">
                {parseFloat(jmlBerat || 0).toFixed(3)} gr
              </span>
            </div>
          </div>

          {/* Pagination Controls */}
          <div className="flex items-center gap-2">
            <span className="text-xs font-bold text-slate-500 dark:text-slate-400">
              Hal {currentPage} dari {page || 1}
            </span>
            <div className="flex items-center gap-1">
              <button
                type="button"
                onClick={prevPage}
                disabled={currentPage <= 1}
                className="p-1.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:border-amber-400 hover:text-amber-600 disabled:opacity-40 disabled:cursor-not-allowed transition cursor-pointer"
                title="Halaman Sebelumnya"
              >
                <IconChevronLeft size={16} />
              </button>
              <button
                type="button"
                onClick={nextPage}
                disabled={currentPage >= page}
                className="p-1.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 hover:border-amber-400 hover:text-amber-600 disabled:opacity-40 disabled:cursor-not-allowed transition cursor-pointer"
                title="Halaman Berikutnya"
              >
                <IconChevronRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
    );
};

export default GaleriBarang;
